<template>
    <app-chrome
        :has-required-alert-fields="hasRequiredAlertFields"
        :alert-fields="platform.alertFields"
        :time-zone="timeZone"
        @update:alert-fields="updateAlertFields"
    >
        <router-view v-if="!hasRequiredAlertFields" />

        <easter-eggs v-if="featureFlags.enableEasterEggs" />
    </app-chrome>
</template>

<script>
import { mapState, mapGetters } from "vuex"

import AppChrome from "./AppChrome"
import EasterEggs from "~/components/elements/EasterEggs"

export default {
    data() {
        return {
            polling: null,
        }
    },

    computed: {
        ...mapState(["platform", "featureFlags"]),
        ...mapState("structure", ["links"]),
        ...mapGetters(["currentUser", "hasRequiredAlertFields", "timeZone"]),
    },

    watch: {
        $route(to, from) {
            const link = this.links.find(l => l.url === to.path)
            if (link) this.$store.commit("setLastSpace", link.url)

            const content = document.getElementsByTagName("html")[0]
            const savedPosition = {
                left: content.scrollLeft,
                top: content.scrollTop,
            }

            this.$store.dispatch("addNavigation", {
                to,
                from,
                savedPosition,
            })
        },
    },

    async created() {
        if (this.platform.hasMailbox) {
            this.startPolling()
        }
    },

    beforeUnmount() {
        if (this.platform.hasMailbox) {
            clearInterval(this.polling)
        }
    },

    methods: {
        startPolling() {
            const { unreadMessagesInterval } = this.platform
            if (!unreadMessagesInterval) return

            window.clearInterval(this.polling)
            this.polling = window.setInterval(() => {
                if (this.currentUser) {
                    this.$store.dispatch("messages/updateUnreadMessages")
                }
            }, unreadMessagesInterval * 1000)
        },

        async updateAlertFields(formData, popModal) {
            await this.$store.dispatch(
                "profile/updateProfileAttribute",
                formData
            )
            this.$store.commit("setAlertFields", [])
            popModal()
        },
    },

    components: {
        AppChrome,
        EasterEggs,
    },
}
</script>
